module.exports = __webpack_public_path__ + "img/Vue.9add7cb9.svg";